<template>
  <div v-observe-visibility="(isVisible) => visibilityChanged(isVisible)">
    <div v-if="this.powerslideEditorVisible">
      <div class="back" v-on:click="goBack">
        Back to Slide List
      </div>

      <div class="item-container">
        <label>Name</label>
        <input type="text" class="name-input" v-model="editPowerSlide.name" maxlength="22" placeholder="Slide Name">
      </div>

      <div class="item-container">
        <label>Slide Duration (Seconds)</label>
        <input type="number" class="duration-input" v-model="editPowerSlide.duration" maxlength="3" placeholder="5">
      </div>

      <div class="item-container">
        <label>Slide Schedule</label>
        <table>
          <tr>
            <td><b>Sunday</b></td>
            <td><b>Monday</b></td>
            <td><b>Tuesday</b></td>
            <td><b>Wednesday</b></td>
            <td><b>Thursday</b></td>
            <td><b>Friday</b></td>
            <td><b>Saturday</b></td>
          </tr>
          <tr>
            <td>Start: <input type="time" v-model="schedule[0].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[1].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[2].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[3].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[4].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[5].start_time"></td>
            <td>Start: <input type="time" v-model="schedule[6].start_time"></td>
          </tr>
          <tr>
            <td>End: <input type="time" v-model="schedule[0].end_time"></td>
            <td>End: <input type="time" v-model="schedule[1].end_time"></td>
            <td>End: <input type="time" v-model="schedule[2].end_time"></td>
            <td>End: <input type="time" v-model="schedule[3].end_time"></td>
            <td>End: <input type="time" v-model="schedule[4].end_time"></td>
            <td>End: <input type="time" v-model="schedule[5].end_time"></td>
            <td>End: <input type="time" v-model="schedule[6].end_time"></td>
          </tr>
        </table>

       <p>* Slides with no schedule with show 24/7 by default</p>

        <button class="button delete small" v-on:click="resetSchedule">
          Reset Schedule
        </button>
      </div>

      <div class="item-container">
        <button class="button" v-on:click="editPosterMyWallSlide" v-if="isPosterMyWallSlide()">
          Edit with PosterMyWall
        </button>
      </div>

      <div class="item-container">
        <button class="button" v-on:click="savePowerSlide">
          Save Changes
        </button>

        <button class="button delete" v-on:click="toggleDeleteSlide" v-if="!deleteSlide">
          Delete Slide
        </button>

        <button class="button" v-on:click="cancelDeleteSlide" v-if="deleteSlide">
          Cancel
        </button>

        <button class="button confirm delete" v-on:click="confirmDeleteSlide" v-if="deleteSlide">
          Confirm Delete
        </button>
      </div>
    </div>
    <div v-if="!this.powerslideEditorVisible">
      <div
        class="slide-container"
        v-on:click="editSelection(slide)"
        v-for="slide in slides"
        v-bind:key="slide._id">
          <div
            class="slide"
            v-bind:style="{ 'background-image': 'url(' + slide.preview_image + '), url(' + slide.image + '), url(https://powerslide-images.s3.amazonaws.com/placeholder.svg)' }" >
          </div>

          <div class="slide-title">
            {{slide.name}}
          </div>
      </div>

      <div class="new-slide" v-on:click="showPosterMyWallEditor">
        <div class="new-slide-title">
          Create a Template Based Slide
        </div>
      </div>

      <div class="new-slide" v-on:click="showUploadForm">
        <div class="new-slide-title">
          Upload Your Slide
        </div>
      </div>

      <div class="upload-container" v-if="this.uploadVisible">
        <div class="upload-form">
          <div class="upload-close" v-on:click="hideUploadForm">
            Close
          </div>
          <input type="file" class="file-input" @change="selectFile" ref="newSlideImage" accept="image/png, image/jpeg, image/gif">

          <div v-if="!uploading" class="upload-text">
            Drag and drop your image below or <br>click to select from file system
          </div>

          <div v-if="uploading" class="uploading-text">
            Your image is uploading...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import Helpers from '../mixins/helpers.js'
import {JSO, Fetcher} from 'jso'

export default {
  name: 'SlideBuilder',

  components: {
    Helpers
  },

  data () {
    return {
      apiKey: 'j9Wt1rlGZjYA7cIfHwN2J0meoD4n84UE',
      callbackResponse: null,
      client: null,
      deleteSlide: false,
      editPowerSlide: null,
      editSlideId: null,
      newImage: '',
      powerslideEditorVisible: false,
      schedule: [
        {
          'day': 'sunday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'monday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'tuesday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'wednesday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'thursday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'friday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'saturday',
          'start_time': '',
          'end_time': ''
        }
      ],
      slides: [],
      token: null,
      tokenResponse: null,
      uploading: false,
      uploadVisible: false
    }
  },

  methods: {
    cancelDeleteSlide: function () {
      this.deleteSlide = false
    },

    confirmDeleteSlide: function () {
      let slideshows = JSON.parse(localStorage.getItem('slideshows'))
      let slideMatch = false

      if (slideshows !== null) {
        slideshows.forEach(slideshow => {
          slideshow.slides.forEach(slide => {
            if (slide._id === this.editPowerSlide._id) {
              slideMatch = true
            }
          })
        })
      }

      if (slideMatch) {
        this.$parent.setCurrentMessage('You cannot delete a slide that is part of a slideshow.', true)
      } else {
        this.axios.delete('/api/slide/' + this.editPowerSlide._id).then((response) => {
          this.getPowerSlides()
          this.$gtag.event('slide-deleted', { method: 'Google' })
          this.$parent.setCurrentMessage('Your slide has been deleted.', false)
          this.goBack()
        }).catch((error) => {
          this.$parent.setCurrentMessage(error, true)
        })
      }
    },

    createSlide: function (image) {
      let data = {
        image: image,
        name: 'User uploaded slide',
        organization_id: PS.user.organization_id,
        type: 'image'
      }

      this.axios.post('/api/slide/', data).then((response) => {
        this.getPowerSlides()
        this.$parent.setCurrentMessage('Your slide has been created', false)
      }).catch((errors) => {
        this.$parent.setCurrentMessage('Failed to create your slide', true)
      })
    },

    createPosterMyWallSlide: function (slide) {
      let data = {
        name: slide.name,
        organization_id: PS.user.organization_id,
        preview_image: slide.preview_url,
        pmw_id: slide.id,
        type: slide.type
      }

      this.axios.post('/api/slide/', data).then((response) => {
        this.getPowerSlides()
        this.$parent.setCurrentMessage('Your PosterMyWall slide has been created', false)
        this.editSlideId = response.data._id
      }).catch((errors) => {
        this.$parent.setCurrentMessage('Failed to create your PosterMyWall slide', true)
      })
    },

    editSelection: function (slide) {
      this.editPowerSlide = slide
      if (this.editPowerSlide.schedule.length > 0) {
        this.schedule = this.editPowerSlide.schedule
      }
      this.togglePowerslideEditor()
    },

    editPosterMyWallSlide: function () {
      if (this.posterMyWallUserId() === undefined) {
        this.getPosterMyWallUser()
      } else {
        this.editSlideId = this.editPowerSlide._id
        let self = this

        // eslint-disable-next-line
        PMW.plugin.editor.openDesign(this.editPowerSlide.pmw_id, 'edit', {onClose: this.posterMyWallClosed, mode: 'normal', sizeFilter: 'desktop-wallpaper', elementsToHide: ['export', 'download'], onSave: function (id) { self.posterMyWallDesignUpdated(id) }})
      }
    },

    getPosterMyWallDownload: function (id) {
      let f = new Fetcher(this.client)
      let url = 'https://api.postermywall.com/v1/users/' + this.posterMyWallUserId() + '/designs/' + id + '/download'
      let data = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }

      f.fetch(url, data)
        .then(response => {
          return response.json()
        })
        .catch((err) => {
          console.error('Error getting downloads: ', err)
        })
    },

    getPosterMyWallUser: function () {
      let opts = {
        redirect_uri: PS.SITE_BASE_URL + '/dashboard'
      }

      this.client.getToken(opts).then((response) => {
        this.token = response.access_token
      }).catch((err) => {
        console.error('Error from passive loader', err)
      })
    },

    getPosterMyWallSlide: function (id) {
      let f = new Fetcher(this.client)
      let url = 'https://api.postermywall.com/v1/users/' + this.posterMyWallUserId() + '/designs/' + id
      let data = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }

      f.fetch(url, data)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          this.updatePosterMyWallSlide(data)
        })
        .catch((err) => {
          console.error('Error from fetcher', err)
        })
    },

    getPosterMyWallSlides: function () {
      let f = new Fetcher(this.client)
      let url = 'https://api.postermywall.com/v1/users/' + this.posterMyWallUserId() + '/designs'
      let data = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }

      f.fetch(url, data)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          this.createPosterMyWallSlide(data[0])
        })
        .catch((err) => {
          console.error('Error from fetcher', err)
        })
    },

    getPowerSlides: function () {
      if (PS.user.organization_id !== undefined) {
        this.axios.get('/api/slides/' + PS.user.organization_id).then((response) => {
          this.slides = []
          response.data.forEach(slide => {
            this.slides.push(slide)
          })
        }).catch((errors) => {
          console.log(errors)
        })
      }
    },

    goBack: function () {
      this.togglePowerslideEditor()
      this.editPowerSlide = null
      this.deleteSlide = false
      this.resetSchedule()
    },

    hideUploadForm: function () {
      this.uploadVisible = false
    },

    isPosterMyWallSlide: function () {
      return this.editPowerSlide.pmw_id !== undefined && this.editPowerSlide.pmw_id !== null
    },

    posterMyWallDesignUpdated: function (id) {
      setTimeout(() => {
        if (this.posterMyWallUserId() !== undefined) {
          this.getPosterMyWallSlide(id)
          this.setPosterMyWallNotification()
          this.getPosterMyWallDownload(id)
        }
      }, 2000)
    },

    posterMyWallSaved: function (id) {
      setTimeout(() => {
        if (this.posterMyWallUserId() !== undefined) {
          this.getPosterMyWallSlides()
          this.setPosterMyWallNotification()
          this.getPosterMyWallDownload(id)
        }
      }, 2000)
    },

    posterMyWallUserId: function () {
      let token = JSON.parse(localStorage.getItem('tokens-PosterMyWall'))

      if (token !== null) {
        return token[0].user_id
      } else {
        return undefined
      }
    },

    resetSchedule: function () {
      this.schedule = [
        {
          'day': 'sunday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'monday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'tuesday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'wednesday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'thursday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'friday',
          'start_time': '',
          'end_time': ''
        },
        {
          'day': 'saturday',
          'start_time': '',
          'end_time': ''
        }
      ]
    },

    savePowerSlide: function () {
      let data = {
        duration: this.editPowerSlide.duration,
        name: this.editPowerSlide.name,
        organization_id: PS.user.organization_id,
        schedule: this.schedule
      }

      this.axios.put('/api/slide/' + this.editPowerSlide._id, data).then((response) => {
        this.$gtag.event('powerslide-slide-updated', { method: 'Google' })
        this.$parent.setCurrentMessage('Your slide has been updated', false)
        this.getPowerSlides()
        this.goBack()
      }).catch((errors) => {
        this.$parent.setCurrentMessage('Failed to update your slide', true)
      })
    },

    selectFile: function () {
      const image = this.$refs.newSlideImage.files[0]
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
      const MAX_SIZE = 30000000 // 30MB
      const tooLarge = image.size > MAX_SIZE

      if (allowedTypes.includes(image.type) && !tooLarge) {
        this.newImage = image
        this.sendFile()
      } else {
        tooLarge ? this.$parent.setCurrentMessage('Image file size is too large. Max size is ' + MAX_SIZE / 1000000 + ' MB', true) : this.$parent.setCurrentMessage('Only images are allowed', true)
      }

      this.$refs.newSlideImage.value = null
    },

    sendFile: async function () {
      const formData = new FormData()
      formData.append('newImage', this.newImage)

      try {
        const res = await this.axios.post('/api/upload', formData)
        this.newImage = ''
        this.hideUploadForm()
        this.createSlide(res.data.file)
      } catch (error) {
        this.$parent.setCurrentMessage(error, true)
      }
    },

    setPosterMyWallNotification: function () {
      this.axios.get('https://api.postermywall.com/v1/settings/set-notification-url?client_id=' + this.apiKey + '&url=https://api.powerslide.app/api/upload/postermywall', {withCredentials: false})
        .then((response) => {
          // console.log('Noticication set')
        }).catch((errors) => {
          console.log(errors)
        })
    },

    showPosterMyWallEditor: function () {
      let self = this

      if (this.posterMyWallUserId() !== undefined) {
        // eslint-disable-next-line
        PMW.plugin.editor.open({contentType: 'image', onClose: this.posterMyWallClosed, mode: 'normal', size: 'desktop-wallpaper', elementsToHide: ['download'], onSave: function (id) { self.posterMyWallSaved(id) }})
      } else {
        this.getPosterMyWallUser()
      }
    },

    showUploadForm: function () {
      this.uploadVisible = true
    },

    toggleDeleteSlide: function (index) {
      this.deleteSlide = true
    },

    togglePowerslideEditor: function () {
      this.powerslideEditorVisible = !this.powerslideEditorVisible
    },

    updatePosterMyWallSlide: function (slide) {
      let data = {
        name: slide.name,
        organization_id: PS.user.organization_id,
        preview_image: slide.preview_url,
        pmw_id: slide.id,
        type: slide.type
      }

      this.axios.put('/api/slide/' + this.editSlideId, data).then((response) => {
        this.$gtag.event('pmw-slide-updated', { method: 'Google' })
        this.$parent.setCurrentMessage('Your slide has been updated', false)
        this.getPowerSlides()
      }).catch((errors) => {
        this.$parent.setCurrentMessage('Failed to update your slide', true)
      })
    },

    visibilityChanged: function (isVisible) {
      if (!isVisible) {
        this.powerslideEditorVisible = false
      }
    }
  },

  mixins: [Helpers],

  mounted () {
    this.client = new JSO({
      providerID: 'PosterMyWall',
      client_id: process.env.VUE_APP_PMW_CLIENT_ID,
      client_secret: process.env.VUE_APP_PMW_CLIENT_SECRET,
      redirect_uri: PS.SITE_BASE_URL + '/dashboard',
      authorization: 'https://api.postermywall.com/v1/oauth/authorize',
      debug: false,
      response_type: 'code',
      token: 'https://api.postermywall.com/v1/oauth/token'
    })

    this.client.callback()
  },

  props: ['refresh'],

  watch: {
    refresh: function (newVal, oldVal) {
      this.getPowerSlides()
    }
  }
}
</script>

<style scoped>
  .button {
    display: block;
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 300px;
  }

  .confirm {
    background: var(--confirm);
  }

  .confirm:hover {
    background: var(--confirm-dark) !important;
  }

  .delete {
    background: var(--error);
  }

  .delete:hover {
    background: var(--error-hover) !important;
  }

  .file-input {
    cursor: pointer;
    height: 368px;
    opacity: 0;
    position: absolute;
    width: calc(100% - 2em);
  }

  input[type=text], input[type=number] {
    border: 1px solid #ccc;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin-top: 5px;
    outline: none;
    padding: 1em;
    width: 125px;
  }

  input[type=time] {
    float: right;
    width: 105px;
  }

  .item-container {
    padding: 1em 0;
  }

  label {
    display: block;
    font-size: 1.5em;
  }

  .name-input {
    width: 245px !important;
  }

  .new-slide {
    border: 3px dashed var(--med-grey);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    height: 208px;
    justify-content: space-around;
    margin: 1em;
    position: relative;
    transition: all 0.25s ease-out;
    width: 288px;
  }

  .new-slide:hover {
    background: white;
    border: solid var(--secondary);
    transform: scale(1.1);
  }

  .new-slide-title {
    color: var(--med-grey);
    font-size: 1.5em;
    font-weight: 500;
    left: 50%;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .slide {
    background: rgb(48, 48, 48);
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    border-radius: 6px 6px 0px 0px;
    cursor: pointer;
    height: 162px;
    width: 288px;
  }

  .slide-container {
    background: white;
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.2);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    justify-content: space-around;
    margin: 1em;
    transition: all 0.25s ease-out;
    vertical-align: top;
    width: 288px;
  }

  .slide-container:hover {
    transform: scale(1.1);
  }

  .slide-title {
    color: var(--dashboard-text);
    display: inline-block;
    padding: .75em;
    text-align: left;
  }

  .small {
    font-size: 1em;
    margin-top: 1.5em;
    padding: 1em;
    width: 150px;
  }

  td {
    padding: .5em;
    width: 165px;
  }

  .upload-close {
    background: var(--secondary);
    color: white;
    padding: 1em;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .upload-close:hover {
    background: var(--secondary-dark);
    color: white;
    cursor: pointer;
  }

  .upload-container {
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0, 0.8);
    height: 100%;
    left: 0;
    min-height: 100vh;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    transition: 0.5s;
    width: 100%;
    z-index: 1001;
  }

  .upload-form {
    background: var(--light-grey);
    height: 400px;
    left: 50%;
    padding: 1em;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60vw;
  }

  .upload-form:hover {
    background: white;
  }

  .upload-text {
    font-size: 1.5em;
    text-align: center;
  }
</style>
